// Common Client V2 imports
const {
  ARTICLE_DOMAIN_BLOCKED,
  ARTICLE_LOADED,
  ARTICLES_REPORTED
} = require('client-v2/common/models/article/actions')
const articleModelReducer = require('client-v2/common/models/article/reducer')
// Container imports
const {
  COLLECTIONS_FAILED,
  COLLECTIONS_LOADED,
  COLLECTIONS_LOADING,
  COMMENTS_FAILED,
  COMMENTS_LOADED,
  COMMENTS_LOADING,
  RELATED_FAILED,
  RELATED_LOADED,
  RELATED_LOADING,
  COMMENT_DELETED,
  SELECT_TAB
} = require('./slide-actions')
const ArticleProfileSlideRecord = require('./slide-record')

/* eslint-disable complexity */
function articleProfileSlideReducer(state = new ArticleProfileSlideRecord(), action) {
  const { type, payload = {} } = action
  if (payload.urlId !== state.article['url_id']) {
    if (!state.relatedStream) {
      return state
    }
    // Pass the action along to related stream items
    return state.update('relatedStream', relatedStream => {
      switch (type) {
        case ARTICLE_DOMAIN_BLOCKED:
          return relatedStream.removeArticlesByHostname(payload.hostname)
        case ARTICLES_REPORTED:
          return relatedStream.removeArticlesByUrlIds(payload.urlIds)
        default:
          return relatedStream.itemsReducer(action)
      }
    })
  }
  switch (type) {
    case COLLECTIONS_FAILED:
      return state.setCollectionsFailed()
    case COLLECTIONS_LOADED:
      return state.addCollections(payload)
    case COLLECTIONS_LOADING:
      return state.setCollectionsLoading()
    case COMMENTS_FAILED:
      return state.setCommentsFailed()
    case COMMENTS_LOADED:
      return state.addComments(payload)
    case COMMENTS_LOADING:
      return state.setCommentsLoading()
    case RELATED_FAILED:
      return state.setRelatedFailed()
    case RELATED_LOADED:
      return state.addRelated(payload)
    case RELATED_LOADING:
      return state.setRelatedLoading()
    case COMMENT_DELETED:
      return state.removeComment(payload.commentId)
    case SELECT_TAB:
      return state.setSelectedTab(payload.selectedTab)
    case ARTICLE_LOADED:
      return state.setArticle(payload.article)
    default:
      return state.update('article', article => {
        return articleModelReducer(article, action)
      })
  }
}
/* eslint-enable complexity */

module.exports = articleProfileSlideReducer
